import {
  FavoriteItemOpenedEvent,
  TelemetryEvents
} from '../../common/telemetryEvents/TelemetryEvents';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { FavoriteItemType } from '../../ts/ServerApi/types/IFavorite';
import { Telemetry } from '../../commonInfra/services/Telemetry';

export function maybeSendTelemetry_favoriteItemOpened(item: IContentInfo<FavoriteItemType>) {
  if (item.favorite) {
    Telemetry.sendEvent<FavoriteItemOpenedEvent>({
      type: TelemetryEvents.FavoriteItemOpened,
      favoriteItemType: item.contentType,
      favoriteItemId: item.id,
    });
  }
}
